import { useEffect, useState } from "react";
import "../assets/styles/components/bottom-panel.scss";
import CloseRounded from "../assets/icons/close-rounded";

export default function BottomPanel({
  content,
  closePanel,
  header_close = true,
}) {
  const [close_panel_effect, setClosePanelEffect] = useState("");

  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  const handleClosePanel = () => {
    setClosePanelEffect("close-effect");
    setTimeout(() => {
      document.body.style.overflow = "auto";
      closePanel();
    }, 500);
  };

  return (
    <div
      className={`bottom-panel position-fixed w-100 h-100 ${close_panel_effect}`}
    >
      <div className="bottom-panel__content mx-auto w-100 h-100 shadow-lg overflow-auto ">
        <div
          className={`close-panel mb-2 position-sticky d-flex w-100 ${
            header_close ? "d-inline-block" : "d-none"
          }`}
        >
          <span
            id="close-bottom-panel-button"
            className="p-1 ms-auto"
            onClick={() => handleClosePanel()}
          >
            <CloseRounded size={24} color="#20419a" />
          </span>
        </div>
        <div className="inner-content px-3">{content}</div>
      </div>
    </div>
  );
}
